import { useEffect, useState, type ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { syncConsent, giveConsent } from './consent';
import { PRIVACY_DATE } from '../../lib/legal';
import { track } from '../../lib/telemetry';

/** Angemeldete Nutzer ohne Zustimmung zur aktuellen Datenschutzerklärung müssen erst zustimmen. */
export function ConsentGate({ children }: { children: ReactNode }) {
  const { user, signOut } = useAuth(); const loc = useLocation();
  const [state, setState] = useState<boolean | null>(null);
  const [ok, setOk] = useState(false); const [msg, setMsg] = useState<string | null>(null); const [busy, setBusy] = useState(false);
  const uid = user?.id ?? null;
  useEffect(() => { setState(null); if (uid) syncConsent(uid).then(setState); }, [uid]);
  // Ohne Login, solange unbekannt, bei vorhandener Zustimmung und auf den Rechtsseiten nie blockieren
  if (!uid || state !== false || ['/datenschutz', '/impressum'].includes(loc.pathname)) return <>{children}</>;
  return (
    <section className="screen legal">
      <div><span className="label">Datenschutz</span><h2>Bitte bestätige die Datenschutzerklärung</h2></div>
      <p>Damit wir dein Konto, deine Spielstände, Mehrspieler-Partien und Bestenlisten-Einträge speichern dürfen, brauchen wir deine Zustimmung zur aktuellen Fassung der Datenschutzerklärung (Stand {PRIVACY_DATE}).</p>
      <label className="consent" htmlFor="privacy-gate"><input id="privacy-gate" type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} /><span>Ich habe die <Link to="/datenschutz">Datenschutzerklärung</Link> gelesen und stimme der dort beschriebenen Verarbeitung meiner Daten zu, einschließlich der Anzeige meines Nutzernamens und meiner Ergebnisse in der öffentlichen Bestenliste.</span></label>
      <div className="actions">
        <button type="button" className="yes" disabled={!ok || busy} onClick={async () => { setBusy(true); const err = await giveConsent(uid); setBusy(false); if (err) setMsg(err); else { setState(true); track('User.consentGiven', { via: 'gate' }); } }}>Zustimmen und weiter</button>
        <button type="button" onClick={() => { void signOut(); }}>Abmelden und ohne Konto spielen</button>
      </div>
      {msg && <span className="sub down">{msg}</span>}
    </section>
  );
}
